<template>
  <layout-checkout>
    <template slot="body">
      <h3>Your Cart</h3>
      <p>
        <icon-base width="1em" height="1em">
          <icon-exclamation-circle />
        </icon-base>Legal limitations for maximum amount of product(s) apply.
      </p>
      <transition-group name="PaB-cart-item" tag="div" class="cart__items">
        <div class="PaB-cart-item-wrapper" v-for="cartItem in cartItems" :key="cartItem.product_id">
          <cart-item :editable="true" :cartItem="cartItem"></cart-item>
        </div>
      </transition-group>
      <div class="no-items" v-if="cartItems.length <= 0">
        <h4>Cart is empty</h4>
        <app-button type="secondary" :block="true" label="Continue Shopping" @click.native="$parent.$emit('close')"></app-button>
      </div>
    </template>

    <template slot="actions">
      <order-summary :items="cartItems"></order-summary>
      <p>
        <icon-base width="1em" height="1em">
          <icon-exclamation-circle />
        </icon-base>Member discounts will be applied in-store!
      </p>
      <div class="PaB-button-group" v-if="cartItems.length > 0">
        <app-button type="primary" :block="true" label="Ready to checkout" @click.native="checkout"></app-button>
        <app-button type="secondary" :block="true" label="Continue Shopping" @click.native="$parent.$emit('close')"></app-button>
      </div>
    </template>
  </layout-checkout>
</template>

<style lang="scss" scoped>
.PaB-cart-item-wrapper {
  transition: all 0.2s ease-in;
  opacity: 1;
  transform: translateX(0);
  margin: 5px 0;
}

.PaB-cart-item-leave-active {
  position: absolute;
}

.PaB-cart-item-enter,
.PaB-cart-item-leave-to {
  opacity: 0;
  transform: translateX(-100%);
}

.PaB-cart-item-leave-active {
  position: absolute;
}
</style>

<script>
import LayoutCheckout from '@/components/LayoutCheckout'
import CartItem from '@/components/CartItem'
import AppButton from '@/components/AppButton'
import OrderSummary from '@/components/OrderSummary'
import IconBase from '@/components/IconBase'
import IconExclamationCircle from '@/components/icons/IconExclamationCircle'

export default {
  components: {
    LayoutCheckout,
    CartItem,
    AppButton,
    OrderSummary,
    IconBase,
    IconExclamationCircle
  },
  computed: {
    cart () {
      return this.$store.state.cart
    },
    cartItems () {
      return this.cart.order_items_attributes
    }
  },
  methods: {
    checkout () {
      const currentRoute = this.$router.currentRoute.fullPath.replace(
        /\/$/,
        ''
      )
      this.$router.push(`${currentRoute}/checkout`)
    }
  },
  created () {
    this.eventTracking.sendPageview(this.$router.currentRoute.fullPath)
  }
}
</script>
